import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor() { }

  getNavItems() {
    return [
      {
        title: 'Home',
        icon: 'home',
        path: '/'
      },
      {
        title: 'Products',
        icon: 'list',
        path: '/products'
      },
      {
        title: 'About',
        icon: 'information',
        path: '/about'
      }
    ];
  }
}
